// PDF genérico de reportes en tabla (mismo formato para descargar e imprimir).
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatDate, formatDateTime, todayISO } from '../utils/dates';

const MARCA = [31, 45, 51];    // encabezados de tabla (color del menú)
const ACENTO = [47, 111, 115]; // color principal
const GRIS = [91, 107, 115];
const fecha = formatDate;

/**
 * @param {object} r { titulo, sucursal, desde?, hasta?, filtros: string[], resumen: [etiqueta, valor][],
 *                     columnas: [{ titulo, num? }], filas: string[][], totales?: string[], generadoPor? }
 * @param {object} opts { imprimir: abre el diálogo de impresión en lugar de descargar }
 */
export function exportReporteTablaPdf(r, { imprimir = false } = {}) {
  const pdf = new jsPDF({ orientation: r.columnas.length > 6 ? 'landscape' : 'portrait', unit: 'pt', format: 'a4' });
  const W = pdf.internal.pageSize.getWidth(), H = pdf.internal.pageSize.getHeight(), M = 36;
  let y = M;
  pdf.setFillColor(...ACENTO); pdf.rect(0, 0, W, 6, 'F');
  pdf.setFont('helvetica', 'bold'); pdf.setFontSize(15); pdf.setTextColor(...MARCA); pdf.text(r.titulo, M, y + 10); y += 30;
  pdf.setFont('helvetica', 'normal'); pdf.setFontSize(10); pdf.setTextColor(...GRIS);
  [`Sucursal: ${r.sucursal}`, r.desde && `Periodo: ${r.desde === r.hasta ? fecha(r.desde) : `${fecha(r.desde)} al ${fecha(r.hasta)}`}`,
    ...(r.filtros || []), `Generado: ${formatDateTime(new Date())}${r.generadoPor ? ` por ${r.generadoPor}` : ''}`]
    .filter(Boolean).forEach((t) => { pdf.text(t, M, y); y += 13; });
  y += 6;
  const num = (v) => ({ content: v, styles: { halign: 'right' } });
  const tabla = (opts) => { autoTable(pdf, { startY: y, margin: { left: M, right: M, bottom: 44 }, theme: 'grid',
    styles: { fontSize: 8.5, cellPadding: 3.5, textColor: [31, 41, 51], lineColor: [217, 226, 227] },
    headStyles: { fillColor: MARCA, textColor: 255, fontStyle: 'bold' }, ...opts }); y = pdf.lastAutoTable.finalY + 14; };
  if (r.resumen?.length) tabla({ head: [r.resumen.map(([k]) => num(k))], body: [r.resumen.map(([, v]) => num(v))], bodyStyles: { fontStyle: 'bold', fontSize: 10 } });
  const head = r.columnas.map((c) => (c.num ? num(c.titulo) : c.titulo));
  tabla({ head: [head],
    body: r.filas.length ? r.filas.map((f) => f.map((v, i) => (r.columnas[i].num ? num(v) : v)))
      : [[{ content: 'Sin información con los filtros seleccionados', colSpan: head.length, styles: { textColor: GRIS, fontStyle: 'italic' } }]],
    ...(r.totales ? { foot: [r.totales.map((v, i) => (r.columnas[i]?.num ? num(v) : v))], footStyles: { fillColor: [231, 240, 240], textColor: MARCA, fontStyle: 'bold' } } : {}) });
  const total = pdf.getNumberOfPages();
  for (let i = 1; i <= total; i += 1) {
    pdf.setPage(i); pdf.setFont('helvetica', 'normal'); pdf.setFontSize(8); pdf.setTextColor(...GRIS);
    pdf.text(`${r.titulo} · ${r.sucursal}`, M, H - 22);
    pdf.text(`Página ${i} de ${total}`, W - M, H - 22, { align: 'right' });
  }
  if (imprimir) {
    pdf.autoPrint();
    if (!window.open(pdf.output('bloburl'), '_blank')) pdf.save(`${r.titulo}.pdf`); // ventana bloqueada: lo descarga
    return;
  }
  pdf.save(`${r.titulo.replace(/[^\w]+/g, '_')}_${r.desde || todayISO()}.pdf`);
}
